import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MyPromise } from '../interceptors/myPromise.service';

const DEPENDENCIES_API_URL = `${environment.baseEndpoint}/dependencesv2`;
const API_URL_PHP = `${environment.baseEndpointPHP}`;

@Injectable({
  providedIn: 'root',
})
export class DependencesService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  dependencesAndPreferences(station_id: string) {
    return this.myPromise.to(this.http.get(`${API_URL_PHP}/legal-requirements/dependences/station/${station_id}`));
  }

  updateDateDeliverableParent(station_id: string, data: any) {
    return this.myPromise.to(this.http.put(`${API_URL_PHP}/deliverables/station/${station_id}`, data));
  }

  createLegalRequirement(station_id: string, data: any) {
    return this.myPromise.to(this.http.post(`${API_URL_PHP}/legal-requirements/station/${station_id}`, data));
  }

  getDeliverablesByStationId (station_id: string) {
    return this.myPromise.to(this.http.get(`${API_URL_PHP}/deliverables/station/${station_id}`));
  }
  all() {
    return this.myPromise.to(this.http.get(`${DEPENDENCIES_API_URL}`));
  }

  getRequirementsByDependenceIdAndStationId(stationId: string, dependenceId: string) {
    return this.myPromise.to(this.http.get(`${DEPENDENCIES_API_URL}/station/${stationId}/dependence/${dependenceId}/requirements`));
  }

  getLegalRequirementsByDependenceId(dependenceId: string) {
    return this.myPromise.to(this.http.get(`${DEPENDENCIES_API_URL}/dependence/${dependenceId}/requirements`));
  }

  storeDependenceRequirementsPreferences(stationId: string, data: object) {
    return this.myPromise.to(this.http.post(`${API_URL_PHP}/legal-requirements/station/${stationId}/preferences`, data));
  }

  storeDependenceRequirement(stationId: string, dependenceId: string, data: object) {
    return this.myPromise.to(this.http.post(`${DEPENDENCIES_API_URL}/station/${stationId}/dependence/${dependenceId}/requirements`, data));
  }

  updateDependenceRequirement(stationId: string, dependenceId: string, data: object) {
    return this.myPromise.to(this.http.put(`${DEPENDENCIES_API_URL}/station/${stationId}/dependence/${dependenceId}/requirements`, data));
  }

  getRequirementsByStationId(stationId: string) {
    return this.myPromise.to(this.http.get(`${DEPENDENCIES_API_URL}/station/${stationId}/requirements`));
  }

  storeAgreement (stationId: string, data: any) {
    return this.myPromise.to(this.http.post(`${API_URL_PHP}/legal-requirements/station/${stationId}/agreement`, data));
  }
}
